import { Box, Stack } from '@src/components';
import { SwitchField } from '@src/corelib/forms/base';
import { formatDate } from '@src/utils';
import { useRef } from 'react';
import useAbsencesTimeline from '../../hooks';
import EventForm from './EventForm';

export default function AbsenceEditPanel() {
  const { selectedSlot, calendar, view, isDayView } = useAbsencesTimeline();
  const lastView = useRef(null);

  const onDurationSwitch = (_, value) => {
    if (value) {
      lastView.current = view.type;
      calendar.setDayView(selectedSlot.start);
    } else {
      if (lastView.current) {
        calendar.changeView(lastView.current);
      } else {
        calendar.setMonthView();
      }
    }
  };
  if (!selectedSlot) {
    return false;
  }
  const selectedDate = formatDate(selectedSlot.start);

  return (
    <Box sx={StyleSheet.sidebar}>
      <Stack spacing={2}>
        <Box sx={StyleSheet.header}>{selectedDate}</Box>

        <Box sx={StyleSheet.duration}>
          <SwitchField
            fullWidth
            label="Duration"
            value={isDayView}
            onTitle="Hours"
            offTitle="Days"
            onChange={onDurationSwitch}
          />
        </Box>

        <EventForm hoursView={isDayView} />
      </Stack>
    </Box>
  );
}
const StyleSheet = {
  sidebar: {
    width: '350px',
    paddingTop: '130px',
    paddingLeft: '20px',
  },
  header: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 600,
    padding: '5px 0',
    color: theme.palette.common.white,
    background: theme.palette.common.black,
  }),
  duration: (theme) => ({
    background: theme.palette.common.white,
    paddingBottom: '10px',
    '.MuiFormLabel-root': {
      top: '0px',
    },
    '.MuiFormControlLabel-root': {
      display: 'flex',
      justifyContent: 'center',
      '.MuiFormControlLabel-label': {
        width: '20px',
      },
    },
  }),
};
